import { useState, useEffect, useRef, forwardRef, createRef } from "react";
import "./App.css";
import { Container, Image, Row, Col } from "react-bootstrap";
import Menu from "./components/Navbar";
import Cards from "./components/Cards";
import Evaluacion from "./screens/Evaluacion";
import Resultados from "./screens/Resultados";
import HistoriaClinica from "./screens/HistoriaClinica";
import Informes from "./screens/Informes";
import PlanCorrectivo from "./screens/PlanCorrectivo";
import SesionesCorrectivas from "./screens/SesionesCorrectivas";

import Context from "./Context";
import TestCard from "./components/TestCard";
import CardPhotoPerfil from "./components/informes/print-area-components/CardPhotoPerfil";
import EvaluacionPerfil from "./components/EvaluacionPerfil";
import CardDrawPDF from "./components/informes/print-area-components/CardDrawPDF";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import IOSSwitch from "./components/informes/IOSSwitch";
import ReactGA from "react-ga";
import { PDFDownloadLink, loading } from "@react-pdf/renderer";
import TestPDF from "./components/informes/PDFS/TestPDF";

function App() {
  useEffect(() => {
    ReactGA.initialize("UA-206849127-1");
    ReactGA.pageview("/");
  }, []);

  /* Event analytics */
  const handleEventAnalytics = () => {
    ReactGA.event({
      category: "Links",
      action: "Descarga PDF",
    });
    console.log("react-ga event hi!");
  };

  const [histoClinica, setHistoClinica] = useState({
    // SECTION HISTORIA CLINICA
    // anamnesis 1.1
    motivoConsulta: JSON.parse(localStorage.getItem("localMotivo")),
    diagnosticoMedico: JSON.parse(localStorage.getItem("localDiagnostico")),
    estudiosDiagnosticos: JSON.parse(
      localStorage.getItem("localEstudiosDiagnosticos")
    ),
    medicacion: JSON.parse(localStorage.getItem("localMedicacion")),
    // anamnesis 1.2
    ocupacion: "",
    deportes: "",
    tratamientosActuales: "",
    otrosSintomas: "",
    // anamnesis 1.3
    cirugias: "",
    partos: "",
    accidentes: "",
    alimentacion: "",
  });

  const [clone, setClone] = useState(null);

  const [showIcons, setShowIcons] = useState(true);
  const [showLogo, setShowLogo] = useState(false);

  const localMenuValue = JSON.parse(localStorage.getItem("localMenuValue"));

  const [menuValue, setMenuValue] = useState(localMenuValue);

  /* No context stateSwitch  */
  const [stateSwitch, setStateSwitch] = useState(false);



  const pdfRef = useRef(null);

  // sessionStorage on window load event
  /* window.onload = () => {
    let reloading = sessionStorage.getItem("reloading");
    if (reloading) {
      sessionStorage.removeItem("reloading");

      setTimeout(() => {
        pdfRef.current.click();
      }, 200);

      
    }
  } */
  // Save a session on handlePDF call
  /* const handlePDF = () => {
    sessionStorage.setItem("reloading", "true");

    setTimeout(() => {
      window.location.reload(false);
    }, 200); */

    /* window.location.reload(false); */
  /* }; */

  const handlePDF = () => {
  
    pdfRef.current.click()

  };

  /* new solution useEffect & session storage, https://stackoverflow.com/questions/69149929/refresh-page-after-and-call-a-function-automatically-in-react/69150001?noredirect=1#comment122224429_69150001 */

  /* const handlePdfFlag = 'handle_pdf';
  const handlePDF = () => {
    sessionStorage.setItem( handlePdfFlag, 'true');
    window.location.reload( false );
  };
  useEffect(() => {
    if (sessionStorage.getItem( handlePdfFlag ) === 'true' && pdfRef.current) {
      sessionStorage.removeItem( handlePdfFlag );
      pdfRef.current.click();
    }
  }); */

  /* end solution */


  
  

  const PdfLinkButton = forwardRef((props, ref) => (
    <button style={{ display: "none" }} class="btn btn-primary  mb-5">
      <PDFDownloadLink
        style={{ backgroundColor: "#0A71F1", color: "white" }}
        document={<TestPDF />}
        fileName="Informe CMF.pdf"
      >
       
        <div ref={ref}>
          {/* {({ loading }) => (loading ? "Cargando" : "Descargar PDF ")} */}
          { loading ? "Loading" : "Download PDF"}

        </div>
      </PDFDownloadLink>
    </button>
  ));

  /* const PdfButton = forwardRef(( ref ) => (
    <PDFDownloadLink
      ref={ref}
      style={{ backgroundColor: "#0A71F1", color: "white" }}
      document={<TestPDF />}
      fileName="Informe CMF.pdf"
    >
      {({ loading }) => (loading ? "Cargando" : "Descargar PDF ")}
    </PDFDownloadLink>
  )); */

  return (
    <>
      <Context.Provider
        value={{
          histoClinica,
          setHistoClinica,
          clone,
          setClone,
          showIcons,
          setShowIcons,
          showLogo,
          setShowLogo,
          menuValue,
          setMenuValue,
        }}
      >
        <Container className="web">
          <Menu />
          <div id="print-area-PDF">
            <HistoriaClinica />
            <Evaluacion />
            <Resultados />
            <PlanCorrectivo />
            <Informes />
          </div>
          {/* <div id="print-area-PDF">
          <HistoriaClinica />
          <Evaluacion />
          <Resultados />
          </div> */}

          {/*  <SesionesCorrectivas /> */}

          {/* start PDF */}

          <section id="pdf">

          <div className="text-center">
              <button onClick={ ()=> {window.location.reload(false);} } class="btn btn-warning  mb-5">
                Actualizar Informe
              </button>
              {/* ***** */}
            </div>

            <div className="text-center">
              <button onClick={ handlePDF } class="btn btn-primary  mb-5">
                Descargar en PDF
              </button>
              {/* ***** */}
            </div>

          </section>

           <PdfLinkButton ref={ pdfRef } /> 
         

          {/* <FancyButton
            onClick={() => console.log("hi from of distance")}
            ref={ref}
          >
            Click me!
          </FancyButton>
          <PdfButton
           
            ref={ pdfRef }
          >
            PdfButton
          </PdfButton> */}

          {/* react-pdf */}
          {/* <section id="pdf">
            <div className="text-center">
              <button
                onClick={() => {
                  window.location.reload(false);
                }}
                class="btn btn-primary  mb-5"
              > */}
          {/* <PDFDownloadLink
           
            style={{ display: "none" }}
            document={<TestPDF />}
            fileName="Informe CMF.pdf"
          >
            {({ loading }) => (loading ? "Cargando" : "Descargar PDF ")}
          </PDFDownloadLink> */}
          {/* </button>
            </div>
          </section> */}


          {/* <FormGroup>
            <FormControlLabel
              className="d-flex justify-content-center"
              control={
                <IOSSwitch
                  checked={stateSwitch}
                  onChange={() => {
                    setStateSwitch(!stateSwitch);
                    setShowIcons(!showIcons);
                    setShowLogo(!showLogo);
                  }}
                  name="checkedB"
                />
              }
              label="Versión Imprimir"
            />
          </FormGroup> */}

          <div className="container-button-pdf text-center">
            {/*  <button
              class="btn btn-primary  mb-3"
              id="download"
              onClick={handleEventAnalytics}
            >
              Desgargar PDF
            </button> */}
          </div>

          <div id="print-area-PDF">
            {/*  <div className="header-pdf">
              <Image
                className="logoPDF"
                src="./assets/images/cmf-logo.png"
                alt="logo cmf"
              />
              <h1 className="h1PDF ">Informe de Evaluación y Diagnóstico</h1>
            </div> */}

            {/* <div className="wraper-cards-pdf">
              <div className="card-pdf"></div>
              <CardPhotoPerfil />
              <CardDrawPDF />
            </div>
            <div className="wraper-cards-pdf">
              <div className="card-pdf"></div>
              <div className="card-pdf"></div>
              <div className="card-pdf"></div>
            </div>
            <div className="wraper-cards-pdf">
              <div className="card-pdf"></div>
              <div className="card-pdf"></div>
              <div className="card-pdf"></div>
            </div> */}
          </div>
          {/* end PDF */}
        </Container>
      </Context.Provider>
    </>
  );
}

export default App;